module.exports = ".loader .my-loader {\n  background-color: #009688;\n}\n\n.ball-grid-pulse > div {\n  background-color: #009688!important;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main